<template>
  <div id="fusion-doughnut-chart">
    <fusioncharts style="width: 100%" :type="newVis.chartConfigs.type" :dataFormat="newVis.chartConfigs.dataFormat" :dataSource="newVis.dataSource" dataEmptyMessage="No Data In" :width="newVis.chartConfigs.width" :height="height"> </fusioncharts>
  </div>
</template>

<script>
export default {
  props: {
    containerId: { type: String, default: "container-doughnut-id" },
    containerClass: { type: String, default: "chart-container" },
    vis: { type: Object, default: () => [] },
    height: { type: String, default: "250" }
  },
  data() {
    return {
      newVis: this.vis
    };
  },
  watch: {
    height() {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 1);
    },
    vis() {
      this.newVis = this.vis;
    }
  }
};
</script>
